import type { FlowStep } from '@/data'

export {
  type FormFieldName,
  requiredFormFieldIds,
  availableFormInputs,
} from '../shared/config'

export function getStepType(
  step: FlowStep,
): 'debt-question' | 'qualification' | 'verification' | 'form' {
  const hasButtons = step.inputs.some((i) => i.type === 'radio')
  const hasVerification =
    step.inputs.length > 0 &&
    step.inputs.every((i) => i.type === 'text' && !i.required)

  if (hasVerification) return 'verification'
  if (hasButtons) return 'qualification'
  return 'form'
}

export const defaultSteps: FlowStep[] = [
  {
    ordinal: 1,
    headline: 'Do You Have More Than $25,000 in Debt?',
    sub_headline: '',
    cta_button: '',
    inputs: [
      {
        id: 'btn_yes',
        label: '✓ Yes',
        type: 'radio',
        placeholder: null,
        required: false,
        value: '25001',
        action: 'progress',
      },
      {
        id: 'btn_no',
        label: '✗ No',
        type: 'radio',
        placeholder: null,
        required: false,
        value: '0',
        action: 'downsell',
      },
    ],
  },
  {
    ordinal: 2,
    headline:
      'Which option best describes your current progress with your credit card payments?',
    sub_headline: '',
    cta_button: '',
    inputs: [
      {
        id: 'ontime',
        label: 'Payments are on time',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'progress',
      },
      {
        id: 'behind13',
        label: 'Behind 1-3 months',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'progress',
      },
      {
        id: 'behind4',
        label: 'Behind 4+ months',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'progress',
      },
      {
        id: 'collections',
        label: 'In Collections',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'downsell',
      },
    ],
  },
  {
    ordinal: 3,
    headline: 'Are you employed?',
    sub_headline: '',
    cta_button: '',
    inputs: [
      {
        id: 'employed',
        label: 'Yes',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'progress',
      },
      {
        id: 'unemployed',
        label: 'No',
        type: 'radio',
        placeholder: null,
        required: false,
        action: 'downsell',
      },
    ],
  },
  {
    ordinal: 4,
    headline: 'Verifying Eligibility For Emergency Funds...',
    sub_headline: '',
    cta_button: '',
    inputs: [
      {
        id: 'check_1',
        label: 'Verifying eligibility...',
        type: 'text',
        placeholder: null,
        required: false,
      },
      {
        id: 'check_2',
        label: 'Cross-referencing programs...',
        type: 'text',
        placeholder: null,
        required: false,
      },
      {
        id: 'check_3',
        label: 'Finalizing options...',
        type: 'text',
        placeholder: null,
        required: false,
      },
    ],
  },
  {
    ordinal: 5,
    headline:
      "Congratulations! You're eligible for the Emergency Debt Relief Program!",
    sub_headline:
      'To see how much money you can claim to apply against your credit card debt, please fill out the following information to get your results!',
    cta_button: 'See My Results →',
    inputs: [
      {
        id: 'name',
        label: 'Name',
        type: 'text',
        placeholder: null,
        required: true,
      },
      {
        id: 'email',
        label: 'Email',
        type: 'email',
        placeholder: null,
        required: true,
      },
      {
        id: 'phone',
        label: 'Phone',
        type: 'phone',
        placeholder: null,
        required: true,
      },
      {
        id: 'state',
        label: 'State',
        type: 'select',
        placeholder: null,
        required: true,
      },
    ],
  },
]
